import { ICONS, type IconName } from './icons.generated';

export type { IconName };

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
  /** Give a label only when the icon stands alone and carries meaning. */
  label?: string;
}

export function Icon({ name, size = 20, className, label }: IconProps) {
  return (
    <svg
      viewBox="0 0 256 256"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: generated from our own icon set at build time
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  );
}
